export default {
    jqueryHelpers(){
        $(".tooltipped").tooltip();

        function charactersRemaining(el){
            var parent = el.parents(".character-count");
            var count = el.val().length;
            var max = parent.attr("data-max");
            var remaining = max - count;
            parent.find(".count").text(remaining);
        }
    
        $(".character-count textarea, .character-count input").on("input", function() {
            charactersRemaining($(this));
        });
    
        $(".character-count").each(function(){
            if ($(this).find("textarea").length){
                charactersRemaining($(this).find("textarea"));
            } 
            if ($(this).find("input").length) {
                charactersRemaining($(this).find("input"));
            } 
        });
    }
}